<div class="auto-replenishment-v2">

  <ng-container *ngIf="showComponent">

    <ng-container *ngIf="isProductLinkToPdp">
      <button class="schedule-and-save schedule-n-save-manage" *ngIf="isPcRedesignDisabled && !isProductSubscribed && !isProductOutOfStock() && snsOffer" [attr.aria-label]="adaSnsOfferTitle()  + product.name" id="{{'pg' + product.id + 'Ar'}}"  attr.data-bpn="{{ product.id }}" (click)="processSnsAction('pg' + product.id + 'Ar')" (keydown.enter)="processSnsAction('pg' + product.id + 'Ar')">
        <div class="schedule-and-save__container">
          <span class="schedule-and-save__wrapper schedule-and-save__wrapper--alignment-text">
              <span class="schedule-and-save__content">
                  <span class="link-xs schedule-and-save__content__text" data-qa="ar-schdl-sv">{{ecomDescription}}</span>
              </span>
          </span>
        </div>
      </button>
      <!-- If isPcRedesignDisabled enable al v2 design && product is unsubscribed-->

      <span class="body-text-xs color-neutral-80 pc__text-xxs" data-qa="ar-schdl-sv" *ngIf="!isPcRedesignDisabled && !isProductSubscribed && !isProductOutOfStock() && snsOffer" id="{{'pg' + product.id + 'Ar'}}" attr.data-bpn="{{ product.id }}">
        <span class="sr-only">
          {{ adaSnsOfferTitle() }} for {{ this.product?.fullName?.length ? this.product.fullName : this.product.name }}
        </span>
        <span aria-hidden="true">{{ecomDescription}}</span>
      </span>

      <div class="schedule-and-save schedule-n-save-manage" *ngIf="isPcRedesignDisabled && isProductSubscribed" id="{{'pg' + product.id + 'Ar'}}"  attr.data-bpn="{{ product.id }}">
        <span class="schedule-and-save__container">
          <span class="schedule-and-save__wrapper schedule-and-save__wrapper--alignment">
            <span class="schedule-and-save__content">
              <a role="link" href="{{getARManageLink()}}" 
              [attr.aria-label]="productFulfillDate ? (productFulfillType === 'dug' ? 'Your pickup ' : 'Your ' + productFulfillType + ' ') + ( productFulfillDate | date: 'MMM. dd') : (productFulfillType === 'dug' ? 'Manage scheduled pickup' : 'Manage scheduled ' + productFulfillType) + (product.name)"
               class="link-xs schedule-and-save__content__text" (click)="analyticPickupDeliveryClick($event)">{{productFulfillDate ? (productFulfillType === 'dug' ? 'Your pickup ' : 'Your ' + productFulfillType + ' ') + (productFulfillDate | date: 'MMM. dd') :  productFulfillType === 'dug' ? 'Manage scheduled pickup' : 'Manage scheduled ' + productFulfillType  }}</a>
            </span>
          </span>
        </span>
      </div>
    <!-- If isPcRedesignDisabled enable al v2 design & product is subscribed -->

      <span data-qa="ar-schdld-dt" class="body-text-xs color-neutral-80 pc__text-xxs" *ngIf="!isPcRedesignDisabled && isProductSubscribed" id="{{'pg' + product.id + 'Ar'}}"  attr.data-bpn="{{ product.id }}">
        <span class="sr-only">
          {{ productFulfillDate ? (productFulfillType === 'dug' ? 'Your pickup ' : 'Your ' + productFulfillType + ' ') + (productFulfillDate | date: 'MMM. dd') : (productFulfillType === 'dug' ? 'Manage scheduled pickup' : 'Manage scheduled ' + productFulfillType) + ' ' + (this.product?.fullName?.length ? this.product.fullName : this.product.name) }}
        </span>
        <span aria-hidden="true" >{{productFulfillDate ? (productFulfillType === 'dug' ? 'Your pickup ' : 'Your ' + productFulfillType + ' ') + (productFulfillDate | date: 'MMM. dd') :  productFulfillType === 'dug' ? 'Manage scheduled pickup' : 'Manage scheduled ' + productFulfillType  }} </span>
      </span>
    </ng-container>

    <ng-container *ngIf="!isProductLinkToPdp">
      <ng-container *ngIf="arSubscriptionList?.isNewSnSUser && !isProductOutOfStock()">
        <div class="sns-container p-3">
          <label class="checkbox__group mb-0" for="checkboxLarge" [attr.aria-label]="dataConfig.contents?.snsText +  dataConfig.contents?.snsOffer + dataConfig.contents?.snsDescription">
            <input class="checkbox__input" type="checkbox"
            [checked]="isChecked ? 'checked':''"
            [attr.aria-checked]="isChecked ? 'true' : 'false'"
            id="checkboxLarge"
            (change)="checkValue($event)"
            data-qa="pdp-chckbx-ss"
            (keydown)="checkValue($event)"
            >
            <span class="checkbox__label checkbox__label--lg checkbox__label--dark">
              {{ dataConfig.contents?.snsText }} {{ dataConfig.contents?.snsOffer }}</span>
            <span class="checkbox__checkmark"><span class="svg-checkmark"></span></span>
          </label>
          <div [ngClass]="isChecked? 'sns-container__info__subscribed' : 'sns-container__info'">
            <div class="body-text-xs">{{ dataConfig.contents?.snsDescription }}</div>
            <div class="link-xs" [attr.aria-label]=" dataConfig.contents?.snsAboutProgramText" tabindex="0" id="info-modal-button" role="button" (click)="showModal('infoModal','info-modal-button')" (keydown.enter)="showModal('infoModal','info-modal-button')" data-qa="pdp-abtlnk-ss">{{ dataConfig.contents?.snsAboutProgramText }}</div>
          </div>
          <div data-toggle="tooltip" data-placement="top" data-original-title="Schedule how often you'd like this item." id="infoTooltip"></div>
          <div class="sns-container__repeat d-flex align-items-center" *ngIf="isChecked">
            <div class="svg-repeat" alt="repeat"></div>
            <div class="link-sm ml-2" attr.aria-label="dataConfig.contents?.snsScheduledText Every {{selectedFrequency === 1 ? '': selectedFrequency}} week{{selectedFrequency > 1 ? 's':''}}" tabindex="0" id="frequency-modal-button" role="button" (click)="showModal('freqModal', 'frequency-modal-button')" (keydown.enter)="showModal('freqModal', 'frequency-modal-button')">{{ dataConfig.contents?.snsScheduledText }} Every {{selectedFrequency === 1 ? '': selectedFrequency}} week{{selectedFrequency > 1 ? "s":""}}</div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!arSubscriptionList?.isNewSnSUser && isProductOutOfStock() && isProductSubscribed && productFulfillType.length !== 0 && productFulfillDate.length !== 0">
        <div class="sns-container p-3 mt-4">
            <div class="d-flex align-items-center pb-2">
                <div class="svg-repeat mr-2"></div>
                <div class="word-highlight-sm flex-grow-1">Your next {{productFulfillType === 'dug' ? 'pickup' : productFulfillType}}: {{productFulfillDate | date: 'MMM. dd'}}</div>
                <div class="link-sm sns-container__returning__manage">
                  <a role="link"
                  href="{{getARManageLink()}}"
                  class="sns-modal__default"
                  [attr.aria-label]="productFulfillDate ? 'This item may be restocked by your scheduled' + (productFulfillType === 'dug' ? 'pickup ' : productFulfillType + ' ') + 'date ' + 'Manage your next' + (productFulfillType === 'dug' ? 'pickup ' : productFulfillType + ' ') + ( productFulfillDate | date: 'MMM. dd') : ''"
                  (click)="analyticsManageLinkClick()"
                  >Manage</a>
                </div>
            </div>
            <div class="sns-container__returning__info pt-2">
                <div class="svg-info float-left"></div>
                <div class="body-text-xs ml-4">This item may be restocked by your scheduled {{productFulfillType === 'dug' ? 'pickup' : productFulfillType}} date.
                </div>
            </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!arSubscriptionList?.isNewSnSUser && !isProductOutOfStock() && isProductSubscribed && productFulfillType.length !== 0 && productFulfillDate.length !== 0">
          <div class="sns-container d-flex align-items-center p-3">
            <div class="svg-repeat mr-2"></div>
            <div class="word-highlight-sm flex-grow-1">Your next {{productFulfillType === 'dug' ? 'pickup' : productFulfillType}}: {{productFulfillDate | date: 'MMM. dd'}}</div>
            <div class="link-sm sns-container__returning__manage">
              <a role="link"
              href="{{getARManageLink()}}"
              class="sns-modal__default"
              [attr.aria-label]="productFulfillDate ? 'Manage your next' + (productFulfillType === 'dug' ? 'pickup ' : productFulfillType + ' ') + ( productFulfillDate | date: 'MMM. dd') : ''"
              (click)="analyticsManageLinkClick()"
              >Manage</a>
            </div>
          </div>
      </ng-container>

      <ng-container *ngIf="!arSubscriptionList?.isNewSnSUser && !isProductOutOfStock() && !isProductSubscribed">
        <div class="sns-modal__trigger-btn-container d-flex flex-column">
          <button type="button"
          id="schedule-and-save-modal-button"
          class="btn btn-secondary btn-xl sns-modal__trigger-btn"
          (click)="showModal('addRecurringModal', 'schedule-and-save-modal-button')"
          aria-labelledby="butttonLabel"
          >
          {{ dataConfig.contents?.snsText }} {{ dataConfig.contents?.snsOffer }}
          </button>
          <ng-container *ngIf="arSubscriptionList.fulfillment?.nextOrderFulfillmentDate">
            <div class="sns-modal__trigger-btn text-center">
              <div class="title-xxs mt-2 sns-modal__ada-color">{{ dataConfig.contents?.snsNextRecurringOrderText }}: {{arSubscriptionList.fulfillment.nextOrderFulfillmentDate | date: 'MMM. dd'}}</div>
            </div>
            <div class="sr-only" id="butttonLabel">
              {{ dataConfig.contents?.snsText }} {{ dataConfig.contents?.snsOffer }}. {{ dataConfig.contents?.snsNextRecurringOrderText }}: {{arSubscriptionList.fulfillment.nextOrderFulfillmentDate | date: 'MMM. dd'}}
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!showComponent">
    <div class="ar-spinner">
        <img alt="Loading.." role="presentation" src="/etc/designs/wcax-commons/images/icons/busy.gif">
    </div>
  </ng-container>
</div>
